import { Serializable } from './serializable.class';

export class UlbDevice extends Serializable {
  simIccid: string;
  deviceId: string;
  deviceType: string;
  profileFamily: string;
  ownerAccountName: string;
  ownerAccountId: string;
  ownership: string[];
  status: UlbDeviceStatus;
  name: string;
  group: string;
  ulbConfiguration: string;
  customerProductLabel: string;

  public getResourceName(): string {
    return 'ulb/device';
  }

  public getExportPath(): string {
    return this.getBulkPath().substring(0, this.getBulkPath().length - 4);
  }
}

export enum UlbDeviceStatus {
  ENABLED = 'enabled',
  DISABLED = 'disabled',
}
